<section class="main main-full">
    <div id="pt-3">
        <p class="text-center">{{ message }}</p>
        <p class="text-center">You will be re-directed back to home in {{ seconds }} seconds.</p>
    </div>
</section>
